import {gql} from "@irati/utils/gql"

const fragment = gql`
  fragment publicUserMetadata on UserMetadata {
    uuid
    config {
      favouriteCategoryIds
      favouriteCategories {
        filterable
        name
        url
        uuid
        kind
        image
        locale
        childrenIds
      }
    }
  }
`

export const toString = fragment.loc.source.body

export default fragment
